import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { StyledMapAlert, alertMessage } from '../map/styles';
import { useState } from 'react';
import { CloseIcon } from 'src/assets/icons/CloseIcon';

export const DefaultMessage = () => {
  const [open, setOpen] = useState(true);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Collapse in={open}>
      <StyledMapAlert
        severity="warning"
        variant="standard"
        action={
          <Box>
            <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        }
      >
        <Box sx={alertMessage}>
          <Typography variant="body1" color="text.secondary" data-testid="DefaultMessage">
            You don’t have any sites added. Admins can add them under <b>Settings</b>.
          </Typography>
        </Box>
      </StyledMapAlert>
    </Collapse>
  );
};
